import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/decibel-calculator',
  component: () => import('../../routes/DecibelCalculator.svelte'),
  card: {
    id: 'decibel-calculator',
    title: 'Decibel (dB) Calculator',
    description:
      'Convert between dB and linear ratios for power, voltage, and current. Includes dB SPL (sound pressure), dBm/dBW (absolute power), dBu/dBV (absolute voltage), dBFS (digital audio), inverse mode (dB → ratio), and cascade total of multiple gains.',
    icon: 'graphic_eq',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/decibel-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title:
      'Decibel (dB) Calculator – Power, Voltage, dB SPL, dBm/dBW, dBu/dBV, dBFS, Cascade',
    description:
      'Free decibel (dB) calculator for audio engineering, RF, and signal processing. Convert between dB and linear ratios (power: 10·log10(P1/P2), amplitude: 20·log10(A1/A2)), sound pressure level (dB SPL, ref 20 µPa), absolute power (dBm/dBW), absolute voltage (dBu/dBV), digital audio (dBFS), and cascade multiple gains into a total.',
  },
};

export default meta;
